const MyBdo = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1011 474"
    >
      <path
        fill="transparent"
        opacity="1.000000"
        stroke="none"
        d="
M775.000000,475.000000 
	C516.666687,475.000000 258.833344,475.000000 1.000000,475.000000 
	C1.000000,317.000000 1.000000,159.000000 1.000000,1.000000 
	C338.000000,1.000000 675.000000,1.000000 1012.000000,1.000000 
	C1012.000000,159.000000 1012.000000,317.000000 1012.000000,475.000000 
	C933.166687,475.000000 854.333313,475.000000 775.000000,475.000000 
M280.833038,178.433975 
	C280.539948,178.234009 280.246887,178.034042 278.935883,177.635544 
	C278.839813,178.485092 278.743744,179.334641 278.647644,180.184204 
	C279.376312,179.781006 280.104980,179.377808 280.833038,178.433975 
M578.602173,310.918579 
	C579.505615,301.544067 579.779907,292.155090 577.964783,282.872955 
	C574.203125,263.636200 562.781738,250.161301 545.268616,242.217529 
	C532.883362,236.599701 519.405273,235.066711 505.837006,235.012100 
	C492.179718,234.957138 478.522003,234.992172 464.864502,235.013062 
	C463.606079,235.014984 462.347900,235.199814 461.309998,235.282227 
	C461.309998,278.391205 461.309998,321.110046 461.309998,363.001160 
	C480.842926,363.001160 500.100372,363.768951 519.267151,362.780243 
	C537.594910,361.834808 553.436401,353.853180 565.433472,339.837097 
	C572.246521,331.877411 577.298523,322.570923 578.602173,310.918579 
M717.001587,257.499329 
	C711.735229,249.459213 703.981812,244.170044 695.578674,240.412979 
	C679.709778,233.317932 662.984924,231.893387 645.995361,236.023499 
	C624.065735,241.354507 609.042786,254.681061 601.612732,275.974182 
	C597.290222,288.361633 596.742126,301.307098 599.058472,314.206665 
	C601.688538,328.853546 608.081055,341.810791 619.826111,351.133087 
	C640.097229,367.222595 663.257812,369.664490 687.477112,362.691284 
	C704.271118,357.855957 716.873291,347.120728 724.202637,331.164703 
	C730.039246,318.458466 732.030273,305.076416 730.210266,290.872833 
	C728.647034,278.673187 724.800110,267.793457 717.001587,257.499329 
M406.899017,237.376328 
	C387.140717,232.835236 367.143738,236.017212 347.237427,234.856674 
	C347.237427,278.249969 347.237427,320.966064 347.237427,364.000000 
	C354.930267,364.000000 362.392456,364.118805 369.849457,363.972656 
	C381.584900,363.742706 393.405548,364.120087 405.028351,362.807709 
	C420.404694,361.071503 431.636139,352.554810 437.429230,337.984955 
	C441.714508,327.207306 441.010956,316.497803 434.798279,306.433258 
	C430.697937,299.790680 424.418488,296.092987 417.078796,293.677948 
	C429.320618,285.148773 433.660889,273.460358 429.815948,259.556122 
	C426.739563,248.431091 418.939240,241.029480 406.899017,237.376328 
M148.537201,280.977814 
	C145.937576,283.053772 143.337952,285.129761 141.240524,286.804688 
	C139.948334,276.030304 134.372650,268.791077 120.044548,269.046906 
	C110.259956,269.221588 101.992950,273.418884 94.755051,279.773132 
	C92.376595,281.861176 90.155434,284.128418 87.862343,286.313721 
	C87.511559,286.098846 87.160767,285.884003 86.809982,285.669128 
	C87.199409,280.883789 87.588844,276.098450 87.991524,271.150269 
	C81.569427,271.150269 75.608147,271.150269 69.069908,271.150269 
	C62.359047,301.902771 55.625660,332.758453 48.837296,363.866089 
	C57.069405,363.866089 64.707184,363.866089 72.753494,363.866089 
	C73.490509,360.702026 74.229500,357.456268 75.003654,354.218903 
	C77.993919,341.714294 80.327431,329.001831 84.183632,316.769653 
	C87.918419,304.922607 94.535164,294.786743 107.550072,290.840637 
	C112.384094,289.374939 115.903961,290.617554 116.837769,295.225983 
	C117.578117,298.879669 117.654076,302.946075 116.875244,306.583008 
	C112.799347,325.616364 108.356773,344.571259 103.940437,363.998688 
	C111.465706,363.998688 118.758499,364.077179 126.045456,363.906433 
	C127.035622,363.883240 128.674210,362.764221 128.868332,361.896576 
	C131.366852,350.729584 133.570099,339.496918 136.022934,328.319244 
	C138.981827,314.835449 143.721970,302.234680 155.681595,293.969086 
	C159.575455,291.277924 163.962814,288.580719 169.047165,291.048187 
	C173.402740,293.161926 173.663513,297.439697 172.903610,301.325531 
	C170.305862,314.609467 167.328201,327.819336 164.473129,341.052612 
	C162.857544,348.540863 161.198334,356.019653 159.489243,363.820007 
	C168.161774,363.820007 175.938400,363.820007 183.680420,363.820007 
	C186.637634,350.107391 189.779053,336.616821 192.405731,323.026794 
	C194.585098,311.751099 196.716446,300.412994 197.835739,289.001160 
	C198.860062,278.557770 190.480011,269.382141 178.074997,268.962067 
	C166.662964,268.575531 157.447739,273.416351 148.537201,280.977814 
M242.999969,309.472992 
	C240.290955,296.621887 237.581955,283.770782 234.932190,271.200684 
	C226.859848,271.200684 219.564011,271.200684 211.875793,271.200684 
	C212.280609,274.307953 212.407333,277.225403 213.063889,280.018280 
	C219.359741,306.800171 225.772507,333.554657 232.038483,360.343506 
	C232.426895,362.004150 232.396576,364.168884 231.636719,365.612549 
	C229.696594,369.298584 227.515930,372.933960 224.927567,376.188873 
	C216.607910,386.651031 208.847351,393.982330 192.375259,388.245819 
	C191.366928,387.894653 188.994980,389.185944 188.399399,390.315247 
	C185.782608,395.277039 183.585724,400.460297 180.945908,406.194733 
	C185.762741,407.472870 190.457047,409.408203 195.294571,409.882263 
	C215.831970,411.894928 232.081879,404.266083 242.949387,386.619537 
	C251.036987,373.487030 258.693878,360.066071 266.009125,346.486206 
	C278.522797,323.256165 290.627228,299.805542 302.871704,276.430878 
	C303.722290,274.807129 304.309875,273.045654 305.165436,271.000061 
	C297.785217,271.000061 290.948639,270.802124 284.139191,271.143982 
	C282.506897,271.225952 280.223572,272.736053 279.493195,274.210327 
	C269.860016,293.655548 260.467102,313.219666 250.935562,332.715698 
	C250.499420,333.607788 249.321274,334.137115 248.472351,334.849121 
	C246.582001,326.381012 244.792221,318.363342 242.999969,309.472992 
M841.319031,81.029625 
	C847.041077,84.974686 852.798706,88.869286 858.478882,92.873764 
	C879.817505,107.917412 896.150879,127.408249 908.581116,150.187851 
	C921.482605,173.831223 929.100159,199.041367 928.904053,226.173706 
	C928.830566,236.340683 927.877380,246.519699 926.911438,256.653778 
	C926.455688,261.435699 924.965698,266.113403 924.052612,270.859192 
	C923.352051,274.500610 924.425720,277.840027 928.066223,278.830719 
	C931.721497,279.825439 934.850830,278.168243 935.530762,273.964691 
	C937.420288,262.282867 939.943604,250.636948 940.812012,238.873169 
	C941.949646,223.461487 940.170044,208.081238 936.987427,192.929901 
	C932.756714,172.788940 925.342468,153.803925 914.600220,136.319031 
	C902.435120,116.518295 887.127808,99.315765 868.605530,85.149017 
	C853.954956,73.943436 838.018127,64.974197 820.783020,58.341740 
	C799.433044,50.125774 777.270752,45.920471 754.465637,45.022831 
	C738.491150,44.394062 722.571045,45.604031 707.032166,49.162140 
	C694.407227,52.053013 682.042908,56.164394 669.697693,60.151360 
	C665.111816,61.632393 663.673523,65.255913 665.201172,68.577484 
	C666.483398,71.365402 670.841980,72.379036 674.538208,70.850349 
	C692.858582,63.273407 712.036072,58.498745 731.678040,57.310944 
	C746.577820,56.409916 761.715576,57.659679 776.627197,59.153027 
	C799.516846,61.445351 820.586609,69.764488 841.319031,81.029625 
M885.003357,166.505310 
	C886.988281,170.530502 889.113464,174.493423 890.933533,178.591827 
	C898.089539,194.705521 901.727234,211.773956 902.823730,229.212708 
	C903.709961,243.305725 902.668152,257.387146 900.215332,271.465027 
	C897.101562,289.335663 891.700378,306.407745 885.240662,323.218231 
	C883.803406,326.958588 883.093750,330.385193 886.646179,332.728790 
	C889.937744,334.900269 894.040039,332.627594 895.971252,327.673676 
	C899.049805,319.776306 901.920959,311.790527 904.626892,303.756958 
	C910.930420,285.042938 914.257202,265.617828 914.677002,246.040054 
	C914.986877,231.587952 913.067383,216.956512 910.811829,202.614044 
	C907.960388,184.483185 900.353821,167.841614 890.634644,152.410858 
	C880.819824,136.828171 868.434692,123.432121 853.746094,112.073799 
	C840.122742,101.539139 825.565186,92.706573 809.644287,86.376770 
	C787.813477,77.697319 764.935730,74.704399 741.527161,76.069717 
	C736.029480,76.390373 730.557434,77.437675 725.120300,78.411530 
	C721.438965,79.070900 719.239624,81.529594 720.196777,85.311943 
	C721.188049,89.229424 724.376038,90.417442 728.233704,89.960594 
	C736.638489,88.965240 745.047241,87.195786 753.450562,87.217873 
	C762.194824,87.240868 770.976685,88.726250 779.666504,90.063393 
	C793.431152,92.181404 806.577393,96.851837 818.606079,103.536476 
	C829.974487,109.854134 840.571899,117.712082 850.945312,125.630196 
	C865.125793,136.454285 876.207336,150.098541 885.003357,166.505310 
M954.963928,149.673889 
	C953.758667,147.048126 952.446594,144.465561 951.365051,141.789749 
	C942.317932,119.405495 928.554504,100.132515 912.122620,82.683891 
	C900.654419,70.506134 887.476746,60.361214 873.181885,51.721695 
	C854.182007,40.238613 833.796509,32.170204 811.954895,28.059391 
	C804.137756,26.588125 796.206421,25.643209 788.288452,24.839638 
	C786.043274,24.611786 783.206726,25.136925 781.504700,26.442307 
	C780.397827,27.291239 779.976746,30.764191 780.813782,32.008377 
	C782.041504,33.833210 784.524780,35.435707 786.725586,35.878757 
	C797.969910,38.142342 809.490845,39.255917 820.553955,42.151413 
	C848.452026,49.453045 873.258728,63.022404 894.646057,82.309845 
	C913.187256,99.030556 927.719482,118.845695 938.348450,141.618057 
	C949.545959,165.608505 955.643127,190.652557 955.931824,217.069504 
	C956.029297,225.981613 955.344727,234.902863 954.993958,243.819000 
	C954.871094,246.942734 955.944214,248.771255 959.415710,249.063644 
	C962.857849,249.353546 965.552795,248.481155 965.907288,244.869064 
	C966.804260,235.731400 967.986816,226.544678 967.816223,217.400726 
	C967.640381,207.972275 966.714050,198.425735 964.830933,189.192978 
	C962.173218,176.162262 958.334045,163.372513 954.963928,149.673889 
M767.309082,106.002144 
	C752.725586,103.861687 738.229065,102.055038 723.335205,103.812271 
	C710.250732,105.356018 697.592041,108.168152 685.212097,112.417671 
	C681.809631,113.585594 679.913513,116.229706 681.583008,120.095070 
	C683.244324,123.941566 686.356812,124.908234 689.996338,123.481537 
	C710.628479,115.393814 731.891846,113.413177 753.826172,115.914238 
	C769.054443,117.650658 783.483582,121.952881 797.076294,128.690140 
	C816.448792,138.292267 832.720642,151.759933 845.805542,169.189682 
	C863.475586,192.727066 872.381104,219.122665 872.932861,248.397278 
	C873.056641,254.964996 872.150879,261.546143 872.059326,268.125854 
	C871.989746,273.125580 876.291504,275.743561 880.359131,272.889313 
	C882.279663,271.541748 883.723816,268.282104 883.838928,265.816620 
	C884.250305,257.005920 884.470459,248.131866 883.863281,239.343933 
	C883.295166,231.122299 882.201111,222.829956 880.259277,214.830750 
	C874.864990,192.610367 864.765686,172.771286 849.888062,155.181946 
	C837.577942,140.628082 823.309021,128.569656 806.341248,120.333923 
	C794.173950,114.428207 780.940063,110.719872 767.309082,106.002144 
M841.039551,191.442871 
	C835.913940,184.012985 831.490601,175.956238 825.526489,169.274918 
	C809.890869,151.759247 790.803894,139.307541 768.106995,132.506332 
	C750.960022,127.368156 733.628418,125.618057 715.880737,127.991867 
	C712.105103,128.496872 710.610474,130.415695 710.919189,134.325058 
	C711.212708,138.041473 713.068787,139.102112 716.419373,139.028473 
	C721.415161,138.918671 726.425110,139.206314 731.411377,138.962769 
	C749.039124,138.101761 765.588135,142.501648 781.146118,150.146805 
	C797.871887,158.365845 811.849915,170.100708 822.983276,185.331314 
	C835.807861,202.875702 843.069519,222.456848 844.840454,243.844849 
	C846.476196,263.601013 842.603455,282.667755 834.015625,300.647858 
	C832.396606,304.037476 833.755066,306.729309 836.252563,308.627014 
	C838.706970,310.491974 843.347473,308.657806 844.831726,305.524536 
	C846.064026,302.923309 846.995178,300.180450 848.089050,297.512390 
	C856.172546,277.795654 858.065796,257.152771 855.800720,236.276886 
	C854.111877,220.711700 848.955688,205.918320 841.039551,191.442871 
M781.941833,185.423920 
	C785.847900,189.667801 790.081055,193.658722 793.596191,198.204895 
	C802.681946,209.955948 808.940735,223.091370 810.927917,237.934906 
	C811.710815,243.782608 811.517822,249.754562 812.055359,255.643814 
	C812.390564,259.317169 813.804321,262.396515 818.425903,261.998535 
	C822.458984,261.651184 824.207092,259.321533 823.989807,255.416580 
	C823.697876,250.169785 823.970093,244.788269 822.863098,239.712555 
	C820.819458,230.342407 818.783325,220.817871 815.231873,211.964203 
	C809.555603,197.813248 800.484131,185.863953 788.627197,175.982254 
	C779.966492,168.764389 770.609619,162.920090 760.095154,159.021683 
	C744.674622,153.304306 728.900879,150.605667 712.320312,152.869446 
	C702.661011,154.188309 693.290955,156.173355 684.397339,160.072479 
	C682.635620,160.844849 680.689636,162.745239 680.230042,164.493851 
	C679.790161,166.167328 680.663269,168.753311 681.864502,170.171570 
	C684.297241,173.043579 687.284607,171.581924 690.228271,170.387070 
	C709.602905,162.522736 729.280823,161.798080 749.355835,167.693298 
	C761.310608,171.203934 771.597961,177.549789 781.941833,185.423920 
M783.518616,221.013962 
	C778.811340,210.855682 771.564636,202.795044 762.659119,196.202515 
	C749.200256,186.239273 734.082397,181.379883 717.287476,182.011276 
	C713.470886,182.154755 711.992371,184.366776 711.965332,188.035645 
	C711.938721,191.653976 713.667419,192.873840 717.131348,193.055817 
	C728.346313,193.644989 739.264404,195.543137 749.063232,201.541763 
	C768.256287,213.291321 779.293152,230.022888 779.925293,252.858078 
	C780.088562,258.756165 779.039551,264.687897 779.203857,270.585876 
	C779.245850,272.092773 781.558716,274.311432 783.244934,274.819092 
	C785.894958,275.616943 789.217773,275.408966 789.920288,271.697510 
	C790.853333,266.767822 791.772400,261.763824 791.912170,256.769775 
	C792.257324,244.438278 789.437622,232.715561 783.518616,221.013962 
M277.527252,180.230042 
	C277.831818,179.603088 278.136353,178.976120 278.440918,178.349167 
	C278.022858,178.226166 277.336578,177.890945 277.235504,178.018707 
	C276.889496,178.456146 276.748932,179.056076 277.527252,180.230042 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M578.325684,311.272644 
	C577.298523,322.570923 572.246521,331.877411 565.433472,339.837097 
	C553.436401,353.853180 537.594910,361.834808 519.267151,362.780243 
	C500.100372,363.768951 480.842926,363.001160 461.309998,363.001160 
	C461.309998,321.110046 461.309998,278.391205 461.309998,235.282227 
	C462.347900,235.199814 463.606079,235.014984 464.864502,235.013062 
	C478.522003,234.992172 492.179718,234.957138 505.837006,235.012100 
	C519.405273,235.066711 532.883362,236.599701 545.268616,242.217529 
	C562.781738,250.161301 574.203125,263.636200 577.964783,282.872955 
	C579.779907,292.155090 579.505615,301.544067 578.325684,311.272644 
M530.911621,267.389191 
	C518.601074,261.118958 505.461670,260.538788 492.362183,261.186584 
	C492.362183,287.132996 492.362183,312.535156 492.362183,338.000000 
	C498.554504,338.000000 504.405701,338.315094 510.210358,337.929718 
	C520.123962,337.271545 529.141235,334.063232 536.457886,327.022461 
	C542.561157,321.149414 544.803284,313.715149 546.387573,305.508423 
	C548.741516,293.314697 543.421143,274.697662 530.911621,267.389191 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M717.262451,257.757050 
	C724.800110,267.793457 728.647034,278.673187 730.210266,290.872833 
	C732.030273,305.076416 730.039246,318.458466 724.202637,331.164703 
	C716.873291,347.120728 704.271118,357.855957 687.477112,362.691284 
	C663.257812,369.664490 640.097229,367.222595 619.826111,351.133087 
	C608.081055,341.810791 601.688538,328.853546 599.058472,314.206665 
	C596.742126,301.307098 597.290222,288.361633 601.612732,275.974182 
	C609.042786,254.681061 624.065735,241.354507 645.995361,236.023499 
	C662.984924,231.893387 679.709778,233.317932 695.578674,240.412979 
	C703.981812,244.170044 711.735229,249.459213 717.262451,257.757050 
M648.090881,263.385437 
	C642.815552,266.449921 638.817505,270.646881 635.949585,276.097656 
	C629.250305,288.830505 629.814209,302.313171 632.499329,315.651703 
	C633.834961,322.286285 637.483093,328.410126 643.034058,333.039917 
	C649.797668,338.681091 657.589111,339.814941 666.131042,340.182678 
	C679.676880,340.765869 692.026367,328.869629 695.130615,318.993256 
	C698.449524,308.433563 698.972656,297.837708 696.891235,287.162537 
	C695.140198,278.181854 691.006714,270.139252 683.081482,265.099670 
	C672.193115,258.175873 660.549072,258.243378 648.090881,263.385437 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M407.203979,237.661697 
	C418.939240,241.029480 426.739563,248.431091 429.815948,259.556122 
	C433.660889,273.460358 429.320618,285.148773 417.078796,293.677948 
	C424.418488,296.092987 430.697937,299.790680 434.798279,306.433258 
	C441.010956,316.497803 441.714508,327.207306 437.429230,337.984955 
	C431.636139,352.554810 420.404694,361.071503 405.028351,362.807709 
	C393.405548,364.120087 381.584900,363.742706 369.849457,363.972656 
	C362.392456,364.118805 354.930267,364.000000 347.237427,364.000000 
	C347.237427,320.966064 347.237427,278.249969 347.237427,234.856674 
	C367.143738,236.017212 387.140717,232.835236 407.203979,237.661697 
M395.833405,338.691956 
	C396.579803,338.461365 397.311188,338.130035 398.074982,338.015961 
	C404.586548,337.043610 408.695740,331.456726 409.059692,326.249573 
	C409.508698,319.825073 405.994385,313.613434 399.647003,312.975372 
	C392.535980,312.260620 385.373718,312.055084 378.284363,311.631012 
	C378.284363,321.321106 378.284363,330.052307 378.284363,338.979980 
	C384.036682,338.979980 389.506317,338.979980 395.833405,338.691956 
M385.366333,261.000000 
	C382.954437,261.000000 380.542572,261.000000 378.267395,261.000000 
	C378.267395,270.026764 378.267395,278.408325 378.267395,287.341431 
	C382.765778,286.853973 387.011932,286.756561 391.087646,285.873016 
	C398.444641,284.278107 402.747314,275.836273 400.144501,269.390930 
	C397.561584,262.994995 392.603882,260.995087 385.366333,261.000000 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M148.785965,280.711487 
	C157.447739,273.416351 166.662964,268.575531 178.074997,268.962067 
	C190.480011,269.382141 198.860062,278.557770 197.835739,289.001160 
	C196.716446,300.412994 194.585098,311.751099 192.405731,323.026794 
	C189.779053,336.616821 186.637634,350.107391 183.680420,363.820007 
	C175.938400,363.820007 168.161774,363.820007 159.489243,363.820007 
	C161.198334,356.019653 162.857544,348.540863 164.473129,341.052612 
	C167.328201,327.819336 170.305862,314.609467 172.903610,301.325531 
	C173.663513,297.439697 173.402740,293.161926 169.047165,291.048187 
	C163.962814,288.580719 159.575455,291.277924 155.681595,293.969086 
	C143.721970,302.234680 138.981827,314.835449 136.022934,328.319244 
	C133.570099,339.496918 131.366852,350.729584 128.868332,361.896576 
	C128.674210,362.764221 127.035622,363.883240 126.045456,363.906433 
	C118.758499,364.077179 111.465706,363.998688 103.940437,363.998688 
	C108.356773,344.571259 112.799347,325.616364 116.875244,306.583008 
	C117.654076,302.946075 117.578117,298.879669 116.837769,295.225983 
	C115.903961,290.617554 112.384094,289.374939 107.550072,290.840637 
	C94.535164,294.786743 87.918419,304.922607 84.183632,316.769653 
	C80.327431,329.001831 77.993919,341.714294 75.003654,354.218903 
	C74.229500,357.456268 73.490509,360.702026 72.753494,363.866089 
	C64.707184,363.866089 57.069405,363.866089 48.837296,363.866089 
	C55.625660,332.758453 62.359047,301.902771 69.069908,271.150269 
	C75.608147,271.150269 81.569427,271.150269 87.991524,271.150269 
	C87.588844,276.098450 87.199409,280.883789 86.809982,285.669128 
	C87.160767,285.884003 87.511559,286.098846 87.862343,286.313721 
	C90.155434,284.128418 92.376595,281.861176 94.755051,279.773132 
	C101.992950,273.418884 110.259956,269.221588 120.044548,269.046906 
	C134.372650,268.791077 139.948334,276.030304 141.240524,286.804688 
	C143.337952,285.129761 145.937576,283.053772 148.785965,280.711487 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M243.001190,309.909363 
	C244.792221,318.363342 246.582001,326.381012 248.472351,334.849121 
	C249.321274,334.137115 250.499420,333.607788 250.935562,332.715698 
	C260.467102,313.219666 269.860016,293.655548 279.493195,274.210327 
	C280.223572,272.736053 282.506897,271.225952 284.139191,271.143982 
	C290.948639,270.802124 297.785217,271.000061 305.165436,271.000061 
	C304.309875,273.045654 303.722290,274.807129 302.871704,276.430878 
	C290.627228,299.805542 278.522797,323.256165 266.009125,346.486206 
	C258.693878,360.066071 251.036987,373.487030 242.949387,386.619537 
	C232.081879,404.266083 215.831970,411.894928 195.294571,409.882263 
	C190.457047,409.408203 185.762741,407.472870 180.945908,406.194733 
	C183.585724,400.460297 185.782608,395.277039 188.399399,390.315247 
	C188.994980,389.185944 191.366928,387.894653 192.375259,388.245819 
	C208.847351,393.982330 216.607910,386.651031 224.927567,376.188873 
	C227.515930,372.933960 229.696594,369.298584 231.636719,365.612549 
	C232.396576,364.168884 232.426895,362.004150 232.038483,360.343506 
	C225.772507,333.554657 219.359741,306.800171 213.063889,280.018280 
	C212.407333,277.225403 212.280609,274.307953 211.875793,271.200684 
	C219.564011,271.200684 226.859848,271.200684 234.932190,271.200684 
	C237.581955,283.770782 240.290955,296.621887 243.001190,309.909363 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M840.940063,80.995316 
	C820.586609,69.764488 799.516846,61.445351 776.627197,59.153027 
	C761.715576,57.659679 746.577820,56.409916 731.678040,57.310944 
	C712.036072,58.498745 692.858582,63.273407 674.538208,70.850349 
	C670.841980,72.379036 666.483398,71.365402 665.201172,68.577484 
	C663.673523,65.255913 665.111816,61.632393 669.697693,60.151360 
	C682.042908,56.164394 694.407227,52.053013 707.032166,49.162140 
	C722.571045,45.604031 738.491150,44.394062 754.465637,45.022831 
	C777.270752,45.920471 799.433044,50.125774 820.783020,58.341740 
	C838.018127,64.974197 853.954956,73.943436 868.605530,85.149017 
	C887.127808,99.315765 902.435120,116.518295 914.600220,136.319031 
	C925.342468,153.803925 932.756714,172.788940 936.987427,192.929901 
	C940.170044,208.081238 941.949646,223.461487 940.812012,238.873169 
	C939.943604,250.636948 937.420288,262.282867 935.530762,273.964691 
	C934.850830,278.168243 931.721497,279.825439 928.066223,278.830719 
	C924.425720,277.840027 923.352051,274.500610 924.052612,270.859192 
	C924.965698,266.113403 926.455688,261.435699 926.911438,256.653778 
	C927.877380,246.519699 928.830566,236.340683 928.904053,226.173706 
	C929.100159,199.041367 921.482605,173.831223 908.581116,150.187851 
	C896.150879,127.408249 879.817505,107.917412 858.478882,92.873764 
	C852.798706,88.869286 847.041077,84.974686 840.940063,80.995316 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M884.733276,166.237244 
	C876.207336,150.098541 865.125793,136.454285 850.945312,125.630196 
	C840.571899,117.712082 829.974487,109.854134 818.606079,103.536476 
	C806.577393,96.851837 793.431152,92.181404 779.666504,90.063393 
	C770.976685,88.726250 762.194824,87.240868 753.450562,87.217873 
	C745.047241,87.195786 736.638489,88.965240 728.233704,89.960594 
	C724.376038,90.417442 721.188049,89.229424 720.196777,85.311943 
	C719.239624,81.529594 721.438965,79.070900 725.120300,78.411530 
	C730.557434,77.437675 736.029480,76.390373 741.527161,76.069717 
	C764.935730,74.704399 787.813477,77.697319 809.644287,86.376770 
	C825.565186,92.706573 840.122742,101.539139 853.746094,112.073799 
	C868.434692,123.432121 880.819824,136.828171 890.634644,152.410858 
	C900.353821,167.841614 907.960388,184.483185 910.811829,202.614044 
	C913.067383,216.956512 914.986877,231.587952 914.677002,246.040054 
	C914.257202,265.617828 910.930420,285.042938 904.626892,303.756958 
	C901.920959,311.790527 899.049805,319.776306 895.971252,327.673676 
	C894.040039,332.627594 889.937744,334.900269 886.646179,332.728790 
	C883.093750,330.385193 883.803406,326.958588 885.240662,323.218231 
	C891.700378,306.407745 897.101562,289.335663 900.215332,271.465027 
	C902.668152,257.387146 903.709961,243.305725 902.823730,229.212708 
	C901.727234,211.773956 898.089539,194.705521 890.933533,178.591827 
	C889.113464,174.493423 886.988281,170.530502 884.733276,166.237244 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M954.981934,150.076813 
	C958.334045,163.372513 962.173218,176.162262 964.830933,189.192978 
	C966.714050,198.425735 967.640381,207.972275 967.816223,217.400726 
	C967.986816,226.544678 966.804260,235.731400 965.907288,244.869064 
	C965.552795,248.481155 962.857849,249.353546 959.415710,249.063644 
	C955.944214,248.771255 954.871094,246.942734 954.993958,243.819000 
	C955.344727,234.902863 956.029297,225.981613 955.931824,217.069504 
	C955.643127,190.652557 949.545959,165.608505 938.348450,141.618057 
	C927.719482,118.845695 913.187256,99.030556 894.646057,82.309845 
	C873.258728,63.022404 848.452026,49.453045 820.553955,42.151413 
	C809.490845,39.255917 797.969910,38.142342 786.725586,35.878757 
	C784.524780,35.435707 782.041504,33.833210 780.813782,32.008377 
	C779.976746,30.764191 780.397827,27.291239 781.504700,26.442307 
	C783.206726,25.136925 786.043274,24.611786 788.288452,24.839638 
	C796.206421,25.643209 804.137756,26.588125 811.954895,28.059391 
	C833.796509,32.170204 854.182007,40.238613 873.181885,51.721695 
	C887.476746,60.361214 900.654419,70.506134 912.122620,82.683891 
	C928.554504,100.132515 942.317932,119.405495 951.365051,141.789749 
	C952.446594,144.465561 953.758667,147.048126 954.981934,150.076813 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M767.745605,106.016663 
	C780.940063,110.719872 794.173950,114.428207 806.341248,120.333923 
	C823.309021,128.569656 837.577942,140.628082 849.888062,155.181946 
	C864.765686,172.771286 874.864990,192.610367 880.259277,214.830750 
	C882.201111,222.829956 883.295166,231.122299 883.863281,239.343933 
	C884.470459,248.131866 884.250305,257.005920 883.838928,265.816620 
	C883.723816,268.282104 882.279663,271.541748 880.359131,272.889313 
	C876.291504,275.743561 871.989746,273.125580 872.059326,268.125854 
	C872.150879,261.546143 873.056641,254.964996 872.932861,248.397278 
	C872.381104,219.122665 863.475586,192.727066 845.805542,169.189682 
	C832.720642,151.759933 816.448792,138.292267 797.076294,128.690140 
	C783.483582,121.952881 769.054443,117.650658 753.826172,115.914238 
	C731.891846,113.413177 710.628479,115.393814 689.996338,123.481537 
	C686.356812,124.908234 683.244324,123.941566 681.583008,120.095070 
	C679.913513,116.229706 681.809631,113.585594 685.212097,112.417671 
	C697.592041,108.168152 710.250732,105.356018 723.335205,103.812271 
	C738.229065,102.055038 752.725586,103.861687 767.745605,106.016663 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M841.286987,191.734131 
	C848.955688,205.918320 854.111877,220.711700 855.800720,236.276886 
	C858.065796,257.152771 856.172546,277.795654 848.089050,297.512390 
	C846.995178,300.180450 846.064026,302.923309 844.831726,305.524536 
	C843.347473,308.657806 838.706970,310.491974 836.252563,308.627014 
	C833.755066,306.729309 832.396606,304.037476 834.015625,300.647858 
	C842.603455,282.667755 846.476196,263.601013 844.840454,243.844849 
	C843.069519,222.456848 835.807861,202.875702 822.983276,185.331314 
	C811.849915,170.100708 797.871887,158.365845 781.146118,150.146805 
	C765.588135,142.501648 749.039124,138.101761 731.411377,138.962769 
	C726.425110,139.206314 721.415161,138.918671 716.419373,139.028473 
	C713.068787,139.102112 711.212708,138.041473 710.919189,134.325058 
	C710.610474,130.415695 712.105103,128.496872 715.880737,127.991867 
	C733.628418,125.618057 750.960022,127.368156 768.106995,132.506332 
	C790.803894,139.307541 809.890869,151.759247 825.526489,169.274918 
	C831.490601,175.956238 835.913940,184.012985 841.286987,191.734131 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M781.638306,185.226227 
	C771.597961,177.549789 761.310608,171.203934 749.355835,167.693298 
	C729.280823,161.798080 709.602905,162.522736 690.228271,170.387070 
	C687.284607,171.581924 684.297241,173.043579 681.864502,170.171570 
	C680.663269,168.753311 679.790161,166.167328 680.230042,164.493851 
	C680.689636,162.745239 682.635620,160.844849 684.397339,160.072479 
	C693.290955,156.173355 702.661011,154.188309 712.320312,152.869446 
	C728.900879,150.605667 744.674622,153.304306 760.095154,159.021683 
	C770.609619,162.920090 779.966492,168.764389 788.627197,175.982254 
	C800.484131,185.863953 809.555603,197.813248 815.231873,211.964203 
	C818.783325,220.817871 820.819458,230.342407 822.863098,239.712555 
	C823.970093,244.788269 823.697876,250.169785 823.989807,255.416580 
	C824.207092,259.321533 822.458984,261.651184 818.425903,261.998535 
	C813.804321,262.396515 812.390564,259.317169 812.055359,255.643814 
	C811.517822,249.754562 811.710815,243.782608 810.927917,237.934906 
	C808.940735,223.091370 802.681946,209.955948 793.596191,198.204895 
	C790.081055,193.658722 785.847900,189.667801 781.638306,185.226227 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M783.743164,221.329468 
	C789.437622,232.715561 792.257324,244.438278 791.912170,256.769775 
	C791.772400,261.763824 790.853333,266.767822 789.920288,271.697510 
	C789.217773,275.408966 785.894958,275.616943 783.244934,274.819092 
	C781.558716,274.311432 779.245850,272.092773 779.203857,270.585876 
	C779.039551,264.687897 780.088562,258.756165 779.925293,252.858078 
	C779.293152,230.022888 768.256287,213.291321 749.063232,201.541763 
	C739.264404,195.543137 728.346313,193.644989 717.131348,193.055817 
	C713.667419,192.873840 711.938721,191.653976 711.965332,188.035645 
	C711.992371,184.366776 713.470886,182.154755 717.287476,182.011276 
	C734.082397,181.379883 749.200256,186.239273 762.659119,196.202515 
	C771.564636,202.795044 778.811340,210.855682 783.743164,221.329468 
z"
      />
      <path
        fill="#3F48CC"
        opacity="1.000000"
        stroke="none"
        d="
M280.833649,178.974609 
	C280.104980,179.377808 279.376312,179.781006 278.647644,180.184204 
	C278.743744,179.334641 278.839813,178.485092 279.532867,177.968231 
	C280.288269,178.605118 280.522888,178.829681 280.833649,178.974609 
z"
      />
      <path
        fill="#3F48CC"
        opacity="1.000000"
        stroke="none"
        d="
M277.028625,179.912048 
	C276.748932,179.056076 276.889496,178.456146 277.235504,178.018707 
	C277.336578,177.890945 278.022858,178.226166 278.440918,178.349167 
	C278.136353,178.976120 277.831818,179.603088 277.028625,179.912048 
z"
      />
      <path
        fill="#3F48CC"
        opacity="1.000000"
        stroke="none"
        d="
M280.833344,178.704285 
	C280.522888,178.829681 280.288269,178.605118 280.041809,178.067505 
	C280.246887,178.034042 280.539948,178.234009 280.833344,178.704285 
z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
M531.165955,267.668549 
	C543.421143,274.697662 548.741516,293.314697 546.387573,305.508423 
	C544.803284,313.715149 542.561157,321.149414 536.457886,327.022461 
	C529.141235,334.063232 520.123962,337.271545 510.210358,337.929718 
	C504.405701,338.315094 498.554504,338.000000 492.362183,338.000000 
	C492.362183,312.535156 492.362183,287.132996 492.362183,261.186584 
	C505.461670,260.538788 518.601074,261.118958 531.165955,267.668549 
z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
M648.436401,263.202942 
	C660.549072,258.243378 672.193115,258.175873 683.081482,265.099670 
	C691.006714,270.139252 695.140198,278.181854 696.891235,287.162537 
	C698.972656,297.837708 698.449524,308.433563 695.130615,318.993256 
	C692.026367,328.869629 679.676880,340.765869 666.131042,340.182678 
	C657.589111,339.814941 649.797668,338.681091 643.034058,333.039917 
	C637.483093,328.410126 633.834961,322.286285 632.499329,315.651703 
	C629.814209,302.313171 629.250305,288.830505 635.949585,276.097656 
	C638.817505,270.646881 642.815552,266.449921 648.436401,263.202942 
z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
M395.404663,338.835968 
	C389.506317,338.979980 384.036682,338.979980 378.284363,338.979980 
	C378.284363,330.052307 378.284363,321.321106 378.284363,311.631012 
	C385.373718,312.055084 392.535980,312.260620 399.647003,312.975372 
	C405.994385,313.613434 409.508698,319.825073 409.059692,326.249573 
	C408.695740,331.456726 404.586548,337.043610 398.074982,338.015961 
	C397.311188,338.130035 396.579803,338.461365 395.404663,338.835968 
z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
M385.828827,261.000000 
	C392.603882,260.995087 397.561584,262.994995 400.144501,269.390930 
	C402.747314,275.836273 398.444641,284.278107 391.087646,285.873016 
	C387.011932,286.756561 382.765778,286.853973 378.267395,287.341431 
	C378.267395,278.408325 378.267395,270.026764 378.267395,261.000000 
	C380.542572,261.000000 382.954437,261.000000 385.828827,261.000000 
z"
      />
    </svg>
  );
};

export default MyBdo;
